import { StorageFields } from 'application/constants/localStorage';

export const authService = {
  saveAccessToken(jwt: string) {
    localStorage.setItem(StorageFields.fbToken, jwt);
  },

  getAccessToken() {
    return localStorage.getItem(StorageFields.fbToken);
  },

  checkAuth() {
    return !!localStorage.getItem(StorageFields.fbToken);
  },

  removeToken() {
    localStorage.removeItem(StorageFields.fbToken);
  },

  eraseSessionData() {
    this.removeToken();
  },
};
